import { Product } from "@/types/broadbandProduct";

export const sortProducts = (
	products: Product[],
	sorter: string
): Product[] => {
	switch (sorter) {
		case "recommended":
			return sortAsc(products, "popularity_rank");
		case "price-high-low":
			return sortDesc(products, "monthly_cost");
		case "price-low-high":
			return sortAsc(products, "monthly_cost");
		case "speed-high-low":
			return sortDesc(products, "download_speed");
		case "speed-low-high":
			return sortAsc(products, "download_speed");
		default:
			return sortAsc(products, "popularity_rank");
	}
};

// Generic sort descending function.
export const sortDesc = (arr: Array<any>, field: string | number) => {
	let sorted = arr.slice().sort((a: any, b: any) => {
		const priceA = parseFloat(a[field]);
		const priceB = parseFloat(b[field]);

		if (priceA > priceB) {
			return -1;
		}
		if (priceA < priceB) {
			return 1;
		}
		return 0;
	});

	return sorted;
};

// Generic sort ascending function.
export const sortAsc = (arr: Array<any>, field: string | number) => {
	let sorted = arr.slice().sort((a: any, b: any) => {
		const priceA = parseFloat(a[field]);
		const priceB = parseFloat(b[field]);

		if (priceA < priceB) {
			return -1;
		}
		if (priceA > priceB) {
			return 1;
		}
		return 0;
	});

	return sorted;
};
